module.exports = __webpack_public_path__ + "static/media/left-leaf-signup.c78495fb.webp";